// extracted by mini-css-extract-plugin
export default {"base":"styles_base__OVWaO","container":"styles_container__0pLxn","default":"styles_default__XmFrd"};